/**
 * humanizeLabel — turn a raw param key / feed label into human copy for the
 * confirmation surfaces ("firstName" → "First name", "aiSummary" → "AI
 * summary"). Labels that already contain a space are assumed human and pass
 * through unchanged (resolved fields, explicit `editableParams.label`).
 */

const ACRONYMS: Record<string, string> = { ai: 'AI', url: 'URL', id: 'ID' };

export function humanizeLabel(label: string): string {
  if (label.includes(' ')) return label;
  const words = label
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/[_-]+/g, ' ')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (words.length === 0) return label;
  return words
    .map((w, i) => {
      const lower = w.toLowerCase();
      if (ACRONYMS[lower]) return ACRONYMS[lower];
      return i === 0 ? w.charAt(0).toUpperCase() + w.slice(1) : lower;
    })
    .join(' ');
}
